import React, { Component } from 'react';
import { Container as RBContainer } from 'rebass';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';

import ForgotPasswordForm from '../../Components/ForgotPasswordForm';
import ContentWrapper from '../../Components/ContentWrapper';
import { forgotPassword } from '../../Firebase/api';

const LContainer = styled(RBContainer)`
  min-width: 320px;
  max-width: 440px;
`;

const FORM_STATE = ForgotPasswordForm.FORM_STATE;
class ForgotPassword extends Component {
  state = {
    success: null,
    error: null,
    isLoading: false,
    formState: FORM_STATE.INIT,
  };
  handleForgotPassword = async email => {
    this.setState({ isLoading: true }, async () => {
      const result = await forgotPassword(email);
      this.setState({
        success: !result ? 'ระบบได้ส่งอีเมลสำหรับรีเซ็ตรหัสผ่านไปให้คุณแล้ว' : null,
        error: result ? result : null,
        isLoading: true,
        formState: FORM_STATE.DONE,
      });
    });
  };

  handleGoToPreviousPage = () => {
    this.setState({
      isLoading: false,
      success: null,
      error: null,
      formState: FORM_STATE.INIT,
    });
  };
  render() {
    const { isLogin } = this.props;
    const { formState, isLoading, success, error } = this.state;

    if (isLogin) return <Redirect to={'/dashboard'} />;
    return (
      <ContentWrapper>
        <LContainer>
          <ForgotPasswordForm
            formState={formState}
            loading={isLoading}
            success={success}
            error={error}
            onForgotPasswordClick={this.handleForgotPassword}
            onGoToPreviousPageClick={this.handleGoToPreviousPage}
          />
        </LContainer>
      </ContentWrapper>
    );
  }
}

export default ForgotPassword;
